import gsap from 'gsap';

export const timeline = () =>
	gsap.timeline({
		defaults: { ease: 'power4.inOut', duration: 2 },
	});
